module.exports = __webpack_public_path__ + "assets/images/industry_phase1.a5a43a40bc29bd9134b3fdad0557190c.svg";